(() => {
  if (window.fsUltraDiscoveryBound) return;
  window.fsUltraDiscoveryBound = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.fs-ultra-discovery__trigger');
    if (!trigger) return;
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    const open = trigger.getAttribute('aria-expanded') !== 'true';
    trigger.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  });
  const bindRoomScroll = () => {
    const root = document.querySelector('#MainContent > .shopify-section > is-land > .product-section:not([data-product-handle="membership-program-annual"])');
    if (!root) return;
    root.querySelectorAll('ai-product-room-builder').forEach((builder) => {
      if (builder.dataset.fsStableGallery === 'true' || typeof builder._renderInlineShell !== 'function') return;
      builder.dataset.fsStableGallery = 'true';
      const renderShell = builder._renderInlineShell;
      builder._renderInlineShell = function (...args) {
        const result = renderShell.apply(this, args);
        const region = this.shadowRoot?.querySelector('.ais-product-room-inline');
        if (region && this.classList.contains('ais-product-room-inline-mode')) {
          region.scrollIntoView = () => {};
        }
        return result;
      };
    });
  };
  if (window.customElements) customElements.whenDefined('ai-product-room-builder').then(bindRoomScroll);
  document.addEventListener('shopify:section:load', bindRoomScroll);
  let pending = false;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-fs-ultra-form]')) return;
    event.preventDefault();
    if (pending || form.dataset.complete === 'true') return;
    pending = true;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const cartLink = form.querySelector('.fs-ultra-discovery__cart');
    const label = button.textContent;
    button.disabled = true;
    button.textContent = form.dataset.adding;
    status.hidden = true;
    const finish = (message) => {
      form.dataset.complete = 'true';
      button.hidden = true;
      status.textContent = message;
      status.hidden = false;
      cartLink.hidden = false;
      document.dispatchEvent(new CustomEvent('cart:build'));
    };
    try {
      const check = await fetch(form.dataset.cartUrl + '.js', {credentials:'same-origin', headers:{Accept:'application/json'}});
      if (!check.ok) throw new Error('Cart unavailable');
      const cart = await check.json();
      if (cart.items.some(item => (item.handle || '').includes('membership'))) {
        finish(form.dataset.already);
        return;
      }
      const response = await fetch(form.action + '.js', {method:'POST', body:JSON.stringify({items:[{id:Number(form.dataset.ultraVariant),quantity:1,selling_plan:Number(form.dataset.ultraPlan)}]}), credentials:'same-origin', headers:{Accept:'application/json','Content-Type':'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Add failed');
      finish(form.dataset.added);
    } catch (error) {
      status.textContent = form.dataset.error;
      status.hidden = false;
      cartLink.hidden = false;
      button.disabled = false;
      button.textContent = label;
    } finally {
      pending = false;
    }
  });
})();
